module.exports = __webpack_public_path__ + "static/img/success.2af185e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/success.png
// module id = 4rPT
// module chunks = 0